module.exports = __webpack_public_path__ + "img/iconCamera.1e05b2ce.svg";